{
  "pages": [
    {
      "name": "Commercial hot water standalone",
      "elements": [
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            }
          ],
          "title": "System Information",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "panel9",
          "elements": [
            {
              "type": "boolean",
              "name": "hotReturn",
              "title": "Should the return pipe be red?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Pump"
        },
        {
          "type": "panel",
          "name": "panel7",
          "elements": [
            {
              "type": "boolean",
              "name": "P_hasPump",
              "title": "Is there a pump?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Pump"
        },
        {
          "type": "panel",
          "name": "panel8",
          "visibleIf": "{P_hasPump} = true",
          "elements": [
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "MAGNA3"
                },
                {
                  "value": "TPE",
                  "text": "TPE"
                },
                {
                  "value": "TPE2",
                  "text": "TPE2"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "Alpha",
                  "text": "ALPHA"
                },
                {
                  "value": "UPS",
                  "text": "UPS"
                },
                {
                  "value": "Pump",
                  "text": "Other"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "visibleIf": "{P_type} = \"Magna3\" or {P_type} = \"TPE\" or {P_type} = \"TPE2\" or {P_type} = \"TPE3\"",
              "title": "Enable pump connectivity?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "P_address",
              "visibleIf": "{P_connected} = true",
              "isRequired": false,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Pump"
        }
      ]
    }
  ]
}